(() => {
  const section = document.querySelector('[data-freshin-cart-section]');
  if (!section) return;

  const root = window.Shopify?.routes?.root || '/';
  let updating = false;

  const setBusy = (busy) => {
    updating = busy;
    section.classList.toggle('is-updating', busy);
    section.setAttribute('aria-busy', String(busy));
    section.querySelectorAll('[data-freshin-cart-change], [data-freshin-cart-remove], [data-freshin-cart-quantity]').forEach((element) => {
      if ('disabled' in element) element.disabled = busy;
    });
  };

  const showError = (line, message) => {
    const row = section.querySelector('[data-freshin-cart-line="' + line + '"]');
    const error = row?.querySelector('[data-freshin-cart-error]');
    if (!error) return;
    error.textContent = message || 'We could not update your cart. Please try again.';
    error.hidden = false;
  };

  const changeLine = async (line, quantity) => {
    if (updating) return;
    setBusy(true);
    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0) })
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message);
      }
      window.location.reload();
    } catch (error) {
      showError(line, error.message);
      setBusy(false);
    }
  };

  section.addEventListener('click', (event) => {
    const changeButton = event.target.closest('[data-freshin-cart-change]');
    if (changeButton) {
      const line = changeButton.dataset.line;
      const input = section.querySelector('[data-freshin-cart-quantity][data-line="' + line + '"]');
      if (!input) return;
      const delta = changeButton.dataset.freshinCartChange === 'increase' ? 1 : -1;
      changeLine(line, Number(input.value) + delta);
      return;
    }

    const removeLink = event.target.closest('[data-freshin-cart-remove]');
    if (removeLink) {
      event.preventDefault();
      changeLine(removeLink.dataset.line, 0);
      return;
    }

    const discountButton = event.target.closest('[data-freshin-discount-apply]');
    if (discountButton) {
      const input = section.querySelector('[data-freshin-discount-input]');
      const error = section.querySelector('[data-freshin-discount-error]');
      const code = input?.value.trim();
      if (!code) {
        if (error) error.hidden = false;
        input?.focus();
        return;
      }
      if (error) error.hidden = true;
      window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart'));
    }
  });

  section.addEventListener('change', (event) => {
    const input = event.target.closest('[data-freshin-cart-quantity]');
    if (input) changeLine(input.dataset.line, input.value);
  });

  section.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches('[data-freshin-discount-input]')) {
      event.preventDefault();
      section.querySelector('[data-freshin-discount-apply]')?.click();
    }
  });
})();
